module.exports = __webpack_public_path__ + "static/img/pin-active.293b6c7.svg";